import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './RangeChart.css';

/**
  Simple RangeChart component
  Horizontal line with marker
  indicating a percent 0 - 100
*/
const RangeChart = ({ barWidthPercent, valuePercent, markerClass, labels }) => {
    const leftVal = (() => {
        const left = valuePercent - barWidthPercent / 2;
        if (left < barWidthPercent) {
            return 0;
        }
        const maxLeft = 100 - barWidthPercent;
        if (left > maxLeft) {
            return maxLeft;
        }
        return left;
    })();
    const markerStyle = {
        width: `${barWidthPercent}%`,
        left: `${leftVal}%`
    };

    return (
        <React.Fragment>
            <div className="bar">
                <div
                    className={cn(markerClass, 'marker', {
                        'default-bg': !markerClass
                    })}
                    style={markerStyle}
                />
            </div>

            <div className="labels">
                {labels.map((l) => <div key={`rp-l-${l}`}>{l}</div>)}
            </div>
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

RangeChart.defaultProps = {
    barWidthPercent: 10,
    valuePercent: 0,
    markerClass: '',
    labels: []
};

RangeChart.propTypes = {
    /**
      width of the range marker
      percent of parent contianer
      (0 - 100)
    */
    barWidthPercent: PropTypes.number,
    /**
      value percentage of data
      (0 - 100)
    */
    valuePercent: PropTypes.number,
    /**
      classname to give the marker
      useful for different styling
    */
    markerClass: PropTypes.string,
    /**
      a list of labels to evenly display below chart
    */
    labels: PropTypes.arrayOf(PropTypes.string)
};

export default RangeChart;
